import { CaclRiskScore } from '@/generated/gql/graphql';

export const riskScoreToLevel: Record<CaclRiskScore, 'info' | 'success' | 'warning' | 'error'> = {
  [CaclRiskScore.UNKNOWN]: 'info',
  [CaclRiskScore.LOW]: 'success',
  [CaclRiskScore.MEDIUM]: 'warning',
  [CaclRiskScore.HIGH]: 'error',
};

export const riskScoreToValue: Record<CaclRiskScore, number> = {
  [CaclRiskScore.UNKNOWN]: 0,
  [CaclRiskScore.LOW]: 25,
  [CaclRiskScore.MEDIUM]: 50,
  [CaclRiskScore.HIGH]: 100,
};
